export default {"name":"Default","dark":true};